/** Polite announcements for screen readers through the page's live region (#announcer). */

let pending = 0;

export function announce(message: string): void {
  const region = document.getElementById("announcer");
  if (region === null) return;
  // clear first, so that the same message twice in a row is read again
  region.textContent = "";
  cancelAnimationFrame(pending);
  pending = requestAnimationFrame(() => {
    region.textContent = message;
  });
}
